import React, { Fragment } from "react";
import PropTypes from "prop-types";

import "../styles/screen.scss";

import { Helmet } from "react-helmet";

import GlobalFooter from "./globalFooter";
import GlobalNavigation from "./globalNavigation";

import Theme from "../utils/theme";



const Layout = ({ children }) => (
  
  <Fragment>
    <Helmet>
      <title>{Theme.Site.defaultTitle}</title>
      <meta name="description" content={Theme.Site.description}/>
      <meta property="og:title" content={Theme.Site.defaultTitle}/>
      <meta property="og:description" content={Theme.Site.description}/>
      <meta property="og:image" content="https://thesmithy.io/og-img.jpg"/>
      <meta property="og:url" content="https://thesmithy.io"/>
      <meta property="og:type" content="website"/>
      <meta name="twitter:card" content="summary"/>

      <meta name="twitter:image" content="https://thesmithy.io/og-img.jpg"/>
      <meta name="application-name" content="the-smithy" />
    </Helmet>
    <GlobalNavigation/>
    {children}
    <GlobalFooter/>
  </Fragment>
);

Layout.propTypes = {
  children: PropTypes.any
};

export default Layout;
